<template>
  <div class="backdrop">
    <div class="common search-box">
      <img class="return" src="../../../assets/images/return.png" @click="$router.go(-1)">
      <input type="text" placeholder="请输入物品名称/条码" v-model="keywords" @input="getAssetList()">
      <img class="material-scan" src="../../../assets/images/material-scan-icon.png">
    </div>
    <div class="type-wrapper">
      <div class="type-block area" @click="areaClick">{{area_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
      <div class="type-block state" @click="stateClick">{{status_info}}<img src="../../../assets/images/material-crudejt-down.png"></div>
      <div class="type-block user" @click="userClick">{{keeper_member_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
      <div class="type-block classify" @click="classifyClick">{{category_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
      <div class="type-block classify" @click="warehouseClick">{{storage_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
    </div>
    <div class="common-goods">
      <div class="common-goods-total">共{{totalNum}}种资产</div>
      <div class="common-goods-list" v-for="(detail, index) in asset_list" :key="index" @click="toDetail(detail.asset_id, detail.goods_name)">
        <img class="goods-img" v-if="detail.image_url" :src="detail.image_url">
        <img class="goods-img" v-else src="../../../assets/images/no-picture.jpg">
        <div class="goods-detail">
          <div class="item name">
            <div class="status green" v-if="detail.status == 1">{{detail.status_info}}</div>
            <div class="status blue" v-else-if="detail.status == 2">{{detail.status_info}}</div>
            <div class="status cyan" v-else-if="detail.status == 3">{{detail.status_info}}</div>
            <div class="status purple" v-else-if="detail.status == 4">{{detail.status_info}}</div>
            <div class="status orange" v-else-if="detail.status == 5">{{detail.status_info}}</div>
            <div class="status" v-else>{{detail.status_info}}</div>
            {{detail.goods_name}}
          </div>
          <div class="item">资产编码：{{detail.asset_num}}</div>
          <div class="item">使用人：{{detail.keeper_member_name}}</div>
          <div class="item">存放区域：{{detail.area_name}}</div>
        </div>
      </div>
      <div v-if="see_more" @click="getAssetList(2)" class="more">- 点击查看更多 -</div>
    </div>

    <!-- 选择区域 -->
    <div class="select-mask" v-if="areaPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择区域<img class="close-mask" @click="areaClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="areaData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectArea"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择状态 -->
    <div class="select-mask" v-if="statePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择状态<img class="close-mask" @click="stateClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="stateData" :props="defaultProps" @node-click="selectStatus"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择使用人 -->
    <div class="select-mask" v-if="userPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择使用人<img class="close-mask" @click="userClose" src="../../../assets/images/close.png"></div>
          <div class="search-box" style="padding: 15px 0">
            <input type="text" v-model="userKeywords" placeholder="请输入姓名/手机号" @keyup.enter="findUser" @input="findUser">
          </div>
          <el-tree :data="userData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectKeeper"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择资产分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择资产分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择仓库 -->
    <div class="select-mask" v-if="warehousePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择仓库<img class="close-mask" @click="warehouseClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="warehouseData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectStorage"></el-tree>
        </div>
      </div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetList',
  metaInfo: {
    title: '资产查看'
  },
  data () {
    return {
      loading: false, // 加载动画
      asset_list: [],
      totalNum: 0,
      keywords: '',
      page: 0, // 页码
      see_more: false, // 点击查看更多
      area_id: 0,
      area_name: '全部区域',
      status: 0,
      status_info: '使用状态',
      keeper_member_id: 0,
      keeper_member_name: '使用人',
      category_id: 0,
      category_name: '全部分类',
      storage_id: 0,
      storage_name: '全部仓库',
      areaPopup: false, // 区域
      areaData: [],
      statePopup: false, // 状态
      stateData: [
        {id: 0, label: '使用状态'},
        {id: 1, label: '闲置'},
        {id: 2, label: '领用'},
        {id: 3, label: '借出'},
        {id: 4, label: '转租'},
        {id: 5, label: '维修'},
        {id: 6, label: '损坏'},
        {id: 7, label: '已出售'},
        {id: 8, label: '已交接'},
        {id: 9, label: '已调拨'}
      ],
      userPopup: false, // 使用人
      userData: [],
      allUserData: [],
      userKeywords: '',
      classifyPopup: false, // 分类
      classifyData: [],
      warehousePopup: false, // 仓库
      warehouseData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.getAssetList()
    this.getStorageTree()
    this.getAreaTree()
    this.getUserTree()
    this.getCategoryTree()
  },
  methods: {
    getAssetList (type = 1) {
      this.loading = true
      var assetList = this.asset_list
      if (type === 2) {
        // 查看更多
      } else {
        // 搜索条件有变化，需重新获取列表 和 统计数据
        this.asset_list = []
        this.page = 0
        this.totalNum = 0
        assetList = []
      }
      this.axios.post('/wechat/asset/assetList', {
        member_id: this.memberId,
        village_id: this.villageId,
        keywords: this.keywords,
        area_id: this.area_id,
        status: this.status,
        keeper_member_id: this.keeper_member_id,
        category_id: this.category_id,
        storage_id: this.storage_id,
        page: this.page + 1
      }).then((res) => {
        if (res.data.status === 1) {
          this.asset_list = assetList.concat(res.data.data.asset_list)
          this.totalNum = res.data.data.total
          this.page = res.data.data.page
          if (this.asset_list.length >= res.data.data.total) {
            this.see_more = false
          } else {
            this.see_more = true
          }
          this.loading = false
        } else {
          this.loading = false
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    toDetail (assetId, goodsName) {
      this.$router.push({name: 'AssetDetail', query: {asset_id: assetId}})
    },
    getStorageTree () {
      this.axios.post('/wechat/basic_info/getStorageTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.warehouseData = [{id: 0, label: '全部仓库'}].concat(res.data.data)
        }
      })
    },
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = [{id: 0, label: '全部分类'}].concat(res.data.data)
        }
      })
    },
    getAreaTree () {
      this.axios.post('/wechat/basic_info/getAreaTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.areaData = [{id: 0, label: '全部区域'}].concat(res.data.data)
        }
      })
    },
    getUserTree () {
      this.axios.post('/wechat/basic_info/getVillageMemberTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.allUserData = [{id: 0, label: '使用人'}].concat(res.data.data)
          this.userData = [{id: 0, label: '使用人'}].concat(res.data.data)
        }
      })
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    // 点击盘点仓库
    warehouseClick () {
      this.warehousePopup = true
    },
    // 关闭盘点仓库弹出
    warehouseClose () {
      this.warehousePopup = false
    },
    // 点击使用人
    userClick () {
      this.userPopup = true
    },
    // 关闭使用人弹出
    userClose () {
      this.userPopup = false
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击区域
    areaClick () {
      this.areaPopup = true
    },
    // 关闭区域弹出
    areaClose () {
      this.areaPopup = false
    },
    // 点击状态
    stateClick () {
      this.statePopup = true
    },
    // 关闭状态弹出
    stateClose () {
      this.statePopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.warehousePopup = false
      this.userPopup = false
      this.classifyPopup = false
      this.areaPopup = false
      this.statePopup = false
    },
    selectStorage (data) {
      this.storage_id = data.id
      this.storage_name = data.label
      this.clickBlank()
      this.getAssetList()
    },
    selectArea (data) {
      this.area_id = data.id
      this.area_name = data.label
      this.clickBlank()
      this.getAssetList()
    },
    selectKeeper (data) {
      this.keeper_member_id = data.id
      this.keeper_member_name = data.label.split('-')[0]
      this.clickBlank()
      this.getAssetList()
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.label
      this.clickBlank()
      this.getAssetList()
    },
    selectStatus (data) {
      this.status = data.id
      this.status_info = data.label
      this.clickBlank()
      this.getAssetList()
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.return {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 5px 10px 0 0;
}
.material-scan {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 18px;
  height: 18px;
}
.type-wrapper {
  padding: 0 15px 10px 15px;
  background-color: #ffffff;
}
.type-wrapper .type-block {
  color: #8f8f8f;
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}
.type-wrapper .type-block img {
  width: 10px;
  height: 10px;
  padding-left: 5px;
}
.status {
  padding: 1px 8px;
  font-size: 13px;
  border-radius: 10px;
  font-weight: normal;
  display: inline-block;
  margin-right: 6px;
  color: #ffffff;
  background-color: #b9b9b9;
}
.status.green {
  background-color: #35c53b;
}
.status.orange {
  background-color: #fa6b2c;
}
.status.blue {
  background-color: #25ade0;
}
.status.purple {
  background-color: #d025e0;
}
.status.cyan {
  background-color: #25e0c7;
}
.more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 400px;
  overflow: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Asset/AssetList.vue